export default "__VITE_ASSET__e4Pgxm3o__"